var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.2984 3.75369C16.6487 2.98132 15.4491 2.66626 13.1581 2.66626H4.84177C2.49834 2.66626 1.27841 3.00164 0.631103 3.82395C0 4.62571 0 5.80703 0 7.44201V10.5583C0 13.7257 0.7488 15.334 4.84177 15.334H13.1581C15.1449 15.334 16.2458 15.056 16.958 14.3743C17.6884 13.6754 18 12.5341 18 10.5583V7.44201C18 5.71778 17.9512 4.52949 17.2984 3.75369ZM11.5561 9.43037L7.77966 11.404C7.69523 11.4482 7.60291 11.4701 7.5107 11.4701C7.4063 11.4701 7.30214 11.442 7.20987 11.3861C7.03614 11.2808 6.93006 11.0925 6.93006 10.8894V6.95473C6.93006 6.75197 7.03585 6.56384 7.20923 6.45851C7.38267 6.35318 7.59838 6.34598 7.77832 6.43947L11.5547 8.40042C11.7469 8.50018 11.8675 8.69852 11.8678 8.91493C11.868 9.13151 11.7479 9.33015 11.5561 9.43037Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.80233da8a80bcb620a58eab3f0426978.svg";
export { ForwardRef as ReactComponent };